// extracted by mini-css-extract-plugin
module.exports = {"pageHeading":"PageHeading_pageHeading__kmQ3i","ingress":"PageHeading_ingress__5sN1R"};